export default "__VITE_ASSET__D$GoIkBf__"